import React from 'react';
import PropTypes from 'prop-types';
import {
  // Box,
  Grid2 as Grid,
  Typography
} from '@mui/material'

import { Indicator } from './indicator.jsx';
import {
  GRID_SPACING,
  GRID_ROW_NEW_LINE_OFFSET,
  GRID_ROW_KPI_INDICATOR_SIZE,
  INFO_COUNT_OF_INCOMPLETE_ENCOUNTER_REVIEWS,
  INFO_COUNT_OF_COMPLETED_ENCOUNTER_REVIEWS,
  INFO_AVERAGE_TIME_UNTIL_REVIEW_COMPLETED,
  INFO_MAX_TIME_ENCOUNTER_REVIEW_INCOMPLETE,
  INFO_MAX_TIME_LINE_ITEM_UNWORKED,
  INFO_COUNT_OF_LINE_ITEMS_REJECTED,
  INFO_ESTIMATED_IMPACT_OF_REJECTED_LINE_ITEMS
} from '../constants.js';

function toUSD(num) {
  return `${Number.parseInt(num).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`
}

function KPISection(props) {
  const {
    incompleteEncounterReviewsCount,
    completedEncounterReviewsCount,
    averageTimeUntilEncounterReviewCompleted,
    maxTimeEncounterReviewIncomplete,
    maxTimeLineItemUnworked,
    lineItemsRejectedCount,
    estimatedImpactOfRejectedLineItems
  } = props;

  const formattedImpact = estimatedImpactOfRejectedLineItems === ''
    ? ''
    : `${toUSD(Number.parseInt(estimatedImpactOfRejectedLineItems))}`

  return (
    <Grid container spacing={GRID_SPACING}>
      {/* new row in grid */}
      <Grid offset={GRID_ROW_NEW_LINE_OFFSET} size={GRID_ROW_KPI_INDICATOR_SIZE}>
        <Indicator
          descriptionText="Incomplete Reviews"
          metric={incompleteEncounterReviewsCount}
          footerText=""
          infoText={INFO_COUNT_OF_INCOMPLETE_ENCOUNTER_REVIEWS}
        />
      </Grid>

      <Grid size={GRID_ROW_KPI_INDICATOR_SIZE}>
        <Indicator
          descriptionText="Completed Reviews"
          metric={completedEncounterReviewsCount}
          footerText=""
          infoText={INFO_COUNT_OF_COMPLETED_ENCOUNTER_REVIEWS}
        />
      </Grid>

      <Grid size={GRID_ROW_KPI_INDICATOR_SIZE}>
        <Indicator
          descriptionText="Average Review Time"
          metric={averageTimeUntilEncounterReviewCompleted}
          footerText=""
          infoText={INFO_AVERAGE_TIME_UNTIL_REVIEW_COMPLETED}
        />
      </Grid>

      <Grid size={GRID_ROW_KPI_INDICATOR_SIZE}>
        <Indicator
          descriptionText="Max Time Review Incomplete"
          metric={maxTimeEncounterReviewIncomplete}
          footerText=""
          infoText={INFO_MAX_TIME_ENCOUNTER_REVIEW_INCOMPLETE}
        />
      </Grid>

      {/* new row in grid */}
      <Grid offset={GRID_ROW_NEW_LINE_OFFSET} size={GRID_ROW_KPI_INDICATOR_SIZE}>
        <Indicator
          descriptionText="Max Time Line Item Unworked"
          metric={maxTimeLineItemUnworked}
          footerText=""
          infoText={INFO_MAX_TIME_LINE_ITEM_UNWORKED}
        />
      </Grid>

      <Grid size={GRID_ROW_KPI_INDICATOR_SIZE}>
        <Indicator
          descriptionText="Rejected Line Items"
          metric={lineItemsRejectedCount}
          footerText=""
          infoText={INFO_COUNT_OF_LINE_ITEMS_REJECTED}
        />
      </Grid>

      <Grid size={GRID_ROW_KPI_INDICATOR_SIZE}>
        <Indicator
          descriptionText="Rejection Estimation"
          metric={formattedImpact}
          footerText=""
          infoText={INFO_ESTIMATED_IMPACT_OF_REJECTED_LINE_ITEMS}
        />
      </Grid>
    </Grid>
  );
}

KPISection.propTypes = {
  incompleteEncounterReviewsCount: PropTypes.string.isRequired,
  completedEncounterReviewsCount: PropTypes.string.isRequired,
  averageTimeUntilEncounterReviewCompleted: PropTypes.string.isRequired,
  maxTimeEncounterReviewIncomplete: PropTypes.string.isRequired,
  maxTimeLineItemUnworked: PropTypes.string.isRequired,
  lineItemsRejectedCount: PropTypes.string.isRequired,
  estimatedImpactOfRejectedLineItems: PropTypes.string.isRequired
};

export { KPISection };
